// Generated by script, please do not edit this file.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import * as React from 'react';
import { forwardRef } from 'react';
var HelpOutline = function(props, ref) {
    return /*#__PURE__*/ React.createElement("svg", _object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        ref: ref
    }, props), /*#__PURE__*/ React.createElement("path", {
        d: "M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1m0 9.333a1.167 1.167 0 1 0 0 2.334 1.167 1.167 0 0 0 0-2.334m0-6.416c-1.468 0-2.333.89-2.333 2.333a.583.583 0 1 0 1.166 0c0-.806.35-1.167 1.167-1.167.845 0 1.167.322 1.167 1.167 0 .481-.397.879-1.351 1.197A.58.58 0 0 0 7.417 8v1.167a.583.583 0 1 0 1.166 0v-.762c1.128-.47 1.75-1.189 1.75-2.155 0-1.489-.845-2.333-2.333-2.333"
    }));
};
var ForwardRef = /*#__PURE__*/ forwardRef(HelpOutline);
export default ForwardRef;
